export default __webpack_public_path__ + "static/media/AD.12c07fb6.svg";